import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import styles from './UserInfo.module.scss';

function UserInfo({user, userRole}) {
  return (
    <aside className={styles.container} data-focusid="userInfo">
      <FontAwesomeIcon
        icon={['fad', 'circle-info']}
        color="#40357C"
        size="lg"
      />{' '}
      <span>
        Você está logado como: {user?.first_name} {user?.last_name}
      </span>
      <span>Turma: {userRole?.school_group_name}</span>
      <strong>Usuário: {user?.username}</strong>
      <span>Escola: {userRole?.school_name}</span>
    </aside>
  );
}

export default UserInfo;
